import {
  ProductFraction,
  StoreProduct,
  StoreProductFraction,
} from '@bofrak-backend/shared';
import { apiAdapter } from '../utils';
import { productDb } from './db';

export function isStoreProduct(x: unknown): x is StoreProduct {
  return (
    !!x &&
    typeof x === 'object' &&
    'id' in (x as any) &&
    'store_id' in (x as any) &&
    !isValidISODateString((x as any).deleted_at)
  );
}
export function isValidISODateString(s: unknown): s is string {
  if (typeof s !== 'string') return false;
  const t = Date.parse(s);
  return !Number.isNaN(t);
}

export const getLatestUpdatedAt = (
  product: StoreProduct,
): string | undefined => {
  const timestamps = [
    product.updated_at,
    ...(product.store_product_fractions ?? []).map(
      (fraction: StoreProductFraction) => fraction?.updated_at,
    ),
    ...(product.product_fractions ?? []).map(
      (fraction: ProductFraction) => fraction?.updated_at,
    ),
  ].filter(Boolean) as string[];

  if (timestamps.length === 0) {
    return product.updated_at;
  }

  return timestamps.reduce((latest, current) =>
    new Date(current).getTime() > new Date(latest).getTime() ? current : latest,
  );
};

const toValidDate = (value?: string) => {
  if (!value) return null;

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const fetchOneStoreProduct = async (
  id: string,
  storeId: string,
  merchantId: string,
) => {
  try {
    const product = await apiAdapter.getStoreProduct({
      store_id: storeId,
      merchant_id: merchantId,
      id,
    });
    productDb.storeProducts.put(product);
  } catch (error) {
    console.log(error);
  }
};

export const shouldReplaceExisting = (
  incomingUpdatedAt: string,
  existingUpdatedAt?: string,
  forceUpdate?: boolean,
) => {
  if (forceUpdate) return true;

  const incoming = toValidDate(incomingUpdatedAt);
  const existing = toValidDate(existingUpdatedAt);

  if (!incoming) return false;
  if (!existing) return true;

  return incoming > existing;
};
